import React, {memo, useMemo} from 'react';

import {Box} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {
  AppButton,
  AppButtonVariant,
  ButtonContainer,
} from '@/app/shared-components';

import {formatNamesList} from '../utils';

interface CoparentFooterProps {
  kids: string[];
  onAcceptInvite: () => void;
}

export const CoparentFooter = memo(
  ({kids, onAcceptInvite}: CoparentFooterProps) => {
    const {t} = useTranslation();

    const formattedKids = useMemo(() => formatNamesList(kids), [kids]);

    return (
      <ButtonContainer
        sticky
        withoutBorder>
        <Box className="co-parent-footer">
          {!!formattedKids && (
            <p className="co-parent-footer__access">
              {t('co_parent.invitation.access', {kids: formattedKids})}
            </p>
          )}
          <AppButton
            id="CoparentInvitation_acceptInviteButton"
            label={t('co_parent.invitation.accept_invite')}
            variant={AppButtonVariant.onPrimaryGreen}
            onClick={onAcceptInvite}
          />
        </Box>
      </ButtonContainer>
    );
  },
);

CoparentFooter.displayName = 'CoparentFooter';
